import { memo } from 'react'
import { Sun, Moon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useThemeStore } from '@/shared/store/themeStore'
import { Button } from '@/shared/ui/button'

/**
 * Simple light/dark toggle — single click to switch.
 * memo: no props, three instances live in the app shell, and the D1 profiling
 * showed them re-rendering with every AppLayout commit. The theme store hook
 * still re-renders it when the theme actually changes.
 */
export const ThemeToggle = memo(function ThemeToggle() {
  const { t } = useTranslation()
  const { resolved, setPreference } = useThemeStore()
  const isDark = resolved === 'dark'

  return (
    <Button
      variant="ghost"
      size="icon"
      // max-md: 44 px target for the phone header and drawer (F28); desktop keeps 32.
      className="h-8 w-8 shrink-0 max-md:h-11 max-md:w-11 active:bg-accent"
      aria-label={isDark ? t('common:theme.switchToLight') : t('common:theme.switchToDark')}
      onClick={() => setPreference(isDark ? 'light' : 'dark')}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </Button>
  )
})


